import styled from 'styled-components';

const StyledBlogBanner = styled.div`
  background: ${({ theme }) =>
    `linear-gradient(270deg, ${theme.primaryLink} 2.58%, ${theme.headerBackground} 119.34%)`};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 4em 1em;
  min-height: 400px;
  margin-bottom: 3em;

  .banner-inner {
    max-width: 800px;
    width: 100%;
  }

  h1,
  p {
    color: ${({ theme }) => theme.primaryText};
    text-align: center;
    margin: 0;
  }

  h1 {
    font-size: 6rem;
    line-height: 1.5;
    font-weight: bold;
    color: white;
  }

  p {
    font-size: 2.25rem;
  }

  .search-box-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    background-color: white;
    padding: 0.75em 1em;
    border-radius: 8px;
    margin-top: 2em;

    .search-box {
      display: flex;
      align-items: center;
      width: 100%;
      color: black;
      position: relative;

      .search-icon {
        position: absolute;
        color: red;
      }

      input {
        width: 100%;
        padding: 0 1em;

        &:focus {
          outline: none;
        }
      }
    }

    input,
    .btn {
      border: 0;
      font-size: 1.75rem;
    }

    .btn {
      padding: 0.5em 2em;
      border-radius: 5px;
      color: white;
      background-color: ${({ theme }) => theme.primaryLink};
    }
  }
`;

export const BlogBanner = () => {
  return (
    <StyledBlogBanner>
      <div className="banner-inner">
        <h1>The Brytahub Blog</h1>
        <p>Stories from the easiest and most trusted place to learn and upskill.</p>

        <div className="search-box-container">
          <div className="search-box">
            <div className="search-icon">O</div>
            <input placeholder="Search for the best articles on vocational skill" />
          </div>
          <button className="btn">Search</button>
        </div>
      </div>
    </StyledBlogBanner>
  );
};
